import React from 'react';
import Modal from '../../../modal/modal';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import InfoIcon from '@mui/icons-material/Info';
import TaskIcon from '@mui/icons-material/Task';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import './index.scss';
import TemplateStatCard from './template-state-card';
import MaterialCard from './material-card';

export default function ConfirmSwapModal({
  open,
  onClose,
  onConfirm,
  sourceMaterial,
  targetMaterial,
  affectedCounts = { taskTemplates: 0, itemTemplates: 0, total: 0 },
  loading
}) {
  const counts = affectedCounts || { taskTemplates: 0, itemTemplates: 0, total: 0 };

  return (
    <Modal
      data-cy="confirm-swap-modal"
      open={open}
      onClose={onClose}
      modalHeading={
        <div className="d-flex align-items-center gap-3 heading-container">
          <div className="modal-icon-wrapper">
            <SwapHorizIcon />
          </div>
          <div className="heading d-flex flex-column">
            <div className="mb-0">Confirm Material Swap</div>
            <span className="info">Review and confirm the material replacement</span>
          </div>
        </div>
      }
      size="lg"
      modalSaveTxt="Confirm Swap"
      modalCloseTxt="Cancel"
      onClick={onConfirm}
      showActionBtn
      savebtnClass="btn-confirm-swap"
      cxlbtnClass="btn-cancel-swap"
      primary
      loading={loading} // Button loading state
      modalSaveTxtDisabledClass={loading || counts.total === 0 ? 'disabled-btn' : ''}
    >
      <div className="confirm-swap-modal-body">
        <div className="mb-4">
          <div className="section-header mb-3">
            <SwapHorizIcon className="section-icon" />
            <h6 className="mb-0">Material Swap</h6>
          </div>

          <div className="material-swap-container">
            {/* Source Material Component */}
            <MaterialCard
              type="source"
              data={sourceMaterial}
            />

            {/* Arrow */}
            <div className="swap-arrow">
              <div className="arrow-circle">
                <ArrowBackIcon />
              </div>
            </div>

            {/* Target Material Component */}
            <MaterialCard
              type="target"
              data={targetMaterial}
            />
          </div>
        </div>

        <div className="mb-4">
          <div className="section-header mb-3">
            <TrendingUpIcon className="section-icon" />
            <h6 className="mb-0">Templates to be Updated</h6>
          </div>

          <div className="templates-grid">

            {/* Task Templates Card */}
            <TemplateStatCard
              loading={loading}
              icon={TaskIcon}
              customIconClass="task-icon"
              label="Task Templates"
              count={counts.taskTemplates}
            />

            {/* Item Templates Card */}
            <TemplateStatCard
              loading={loading}
              icon={LabelImportantIcon}
              customIconClass="item-icon"
              label="Item Templates"
              count={counts.itemTemplates}
            />

            {/* Total Updates Card */}
            <TemplateStatCard
              loading={loading}
              icon={TrendingUpIcon}
              label="Total Updates"
              count={counts.total}
              isTotal={true}
            />

          </div>
        </div>

        {/* Info Note */}
        <div className="info-note">
          <div className="info-icon-wrapper">
            <InfoIcon />
          </div>
          <div className="info-content">
            <strong>Important:</strong> This operation preserves quantity values from the source material when replacing with the target material. All related templates and items will be automatically updated.
          </div>
        </div>
      </div>
    </Modal>
  );
}